import React from 'react'
import { t } from 'ttag'

const LoadingIndicator = ({
  newSiteLook,
  unContained,
  small = false,
  suppressTopMargin = false
}) => {
  if (newSiteLook) {
    let className = ''

    if (small) {
      className = `${className} small`
    }

    if (suppressTopMargin) {
      className = `${className} no-top-margin`
    }

    return (
      <div className={unContained ? '' : 'container'}>
        <div id="loadersequence" className={className}>
          <div className="loadingtext">{t`Loading, please wait...`}</div>
          <img
            aria-hidden="true"
            alt={t`Animated loading image`}
            src={
              dynamicValues.deploymentTypeConfig?.typeId == 2
                ? `/images/library/app/H2-Library-Chevron-01.svg`
                : `/images/headed2/new/logo/icon.svg`
            }
          />
        </div>
      </div>
    )
  }

  return <span>{t`Loading, please wait...`}</span>
}

export default LoadingIndicator
